import { Card, CardContent } from "@/components/ui/card";
import Section from "@/components/Section";
import christofferPhoto from "@/assets/christoffer-frisell.jpg";
import henrikPhoto from "@/assets/henrik-bystrom.jpg";
import mikkelPhoto from "@/assets/mikkel-ronningen.jpg";
import lindaPhoto from "@/assets/linda-pimmeshofer.jpg";
import fredrikPhoto from "@/assets/fredrik-wallner.jpg";

const teamMembers = [
  {
    name: "Christoffer Frisell",
    title: "CEO & CO-FOUNDER",
    bio: "A thought, structured leader with a growth mindset managing the start-up AI Lab Sweden (AI-labbet). Combined experience from the Corporate environment (18 yrs) at Microsoft and as CEO (10 yrs) at a successful smaller Private equity organization. Provides valuable learnings and knowledge in the broad area of Management and interest in evolutionary technology shifts, cultural drivers of leadership along with a true passion of developing effective teams in an entrepreneurial environment.",
    photo: christofferPhoto,
    imagePosition: "center center",
  },
  {
    name: "Henrik Byström",
    title: "CO-FOUNDER & HEAD OF AI BUSINESS STRATEGY",
    bio: "Henrik Byström is one of Sweden's foremost experts in artificial intelligence. For more than three decades, he has helped organizations innovate their ways of working through technology and change management, and he has been a driving force in the development of modern ways of using technology to create business results where technology, leadership and employee culture are united with people at the center. Today, Henrik guides boards of directors, management teams and businesses through the AI revolution.",
    photo: henrikPhoto,
    imagePosition: "center center",
  },
  {
    name: "Mikkel Rönningen",
    title: "DPO & HEAD OF RESPONSIBLE AI",
    bio: "Mikkel is a business lawyer and Head of Responsible AI at AI-Labbet. With a strong interest in new technologies, his focus is on the responsible deployment and adoption of AI. Mikkel supports both private and public sector organizations navigate the complexities of digital transformation, ensuring that data protection and cybersecurity are prioritized.",
    photo: mikkelPhoto,
    imagePosition: "center center",
  },
  {
    name: "Linda Pimmeshofer",
    title: "EXPERT ADVISOR, RETAIL & DIGITAL TRANSFORMATION",
    bio: "After more than 20 years in the software industry, Linda believes there has never been a more exciting or challenging time at the intersection of retail and technology. She works to inspire retailers to embrace digital transformation, with a strong focus on being customer-centric and data-driven. For Linda, digitalization is about embedding intelligence in every process to make informed decisions and create personalized, relevant customer experiences—the only path to profitability and sustainability in an ever-changing world.",
    photo: lindaPhoto,
    imagePosition: "center 30%",
  },
  {
    name: "Fredrik Wallner",
    title: "EXPERT ADVISOR, PR & MARKETING",
    bio: "Fredrik is a seasoned PR and marketing professional with a passion for turning complex, technical language into engaging and valuable communication for both readers and senders. With extensive experience in industry-leading companies like Microsoft, Capgemini, and Telia, he brings a wealth of expertise to his work. Additionally, Fredrik is an entrepreneur and co-founder of Moodscores, a company that provides insights into the emotional impact of advertising.",
    photo: fredrikPhoto,
    imagePosition: "center center",
  },
];

const TeamSection = () => {
  return (
    <Section
      eyebrow="The team"
      title={<>Meet our <span className="text-gradient-brand">network</span></>}
      description="A network of professionals with diverse backgrounds and deep expertise across industries and technologies."
      containerSize="wide"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {teamMembers.map((member) => (
          <Card
            key={member.name}
            className="h-full flex flex-col overflow-hidden border-border/60 bg-card/80 backdrop-blur-sm"
          >
            <CardContent className="p-0 flex flex-col h-full">
              <div className="aspect-[4/3] overflow-hidden bg-muted relative">
                <img
                  src={member.photo}
                  alt={member.name}
                  width="800"
                  height="600"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: member.imagePosition }}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-6 space-y-3 flex-grow">
                <h3 className="text-2xl font-bold text-foreground">
                  {member.name}
                </h3>
                <p className="text-sm font-semibold text-gradient-brand uppercase tracking-wide">
                  {member.title}
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </Section>
  );
};

export default TeamSection;
